<template>
  <div class="header-box">
    <header class="w-box">
      <!-- header 第一块 -->
      <div class="wh-top">
        <div class="nav-logo">
          <router-link to="/" tag="h1" title="中海医药官网"></router-link>
        </div>
        <div class="right-nav">
        <div class="right-nav" style="float: right;height: 40px;margin-top:10px;">
          
            <div class="service-item service-time-item">
              <h4>工作日09:00~17:30</h4>
              <!-- <h5>在线咨询</h5> -->
            </div>
            <div class="service-item service-phone-item">
              <h4 style="padding-top:0;">电话</h4>
              <h5>028-85145501</h5>
            </div>
            <div>
              <el-button v-if="!userInfo || !userInfo.ID" class="register-btn" @click="registerDialogVisible = true">注册账号</el-button>
              <router-link tag="p" v-if="userInfo && userInfo.ID" class="yuding-view" :to="{name:'Reservation'}">已预定({{$store.state.PreOrderCount}})</router-link>
            </div>
            <div>
              <el-button v-if="!userInfo || !userInfo.ID" class="login-btn them-btn" @click="loginDialogVisible = true">登录</el-button>
              <el-dropdown v-if="userInfo && userInfo.ID" @command="handleCommand">
                <el-button class="login-btn them-btn">{{userInfo.Name}}</el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="MyChair">我的讲座</el-dropdown-item>
                    <el-dropdown-item command="MyComments">我的评论</el-dropdown-item>
                    <el-dropdown-item command="MyCollection">我的收藏</el-dropdown-item>
                    <el-dropdown-item command="Lecturer">我的讲师</el-dropdown-item>
                    <el-dropdown-item command="Reservation">我的预定</el-dropdown-item>
                    <el-dropdown-item command="Information">我的资料</el-dropdown-item>
                    <el-dropdown-item command="publish" v-if="userInfo.UserGroup != 0">发布讲座</el-dropdown-item>
                    <el-dropdown-item command="exit">退出账号</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
        </div>
        <div style="float: right;font-size: 12px;padding-top: 7px;">《互联网药品信息服务资格证书》编号：（川）-非经营性-2021-0035    </div>
        </div>
      </div>
      <!-- header 第二块 -->
      <slot name="nemu"> 
        <div class="wh-nav-box">
          <div class="wh-nav">
            <div class="nav-sub-wrapper">
              <router-link
                v-for="nav in navList"
                tag="a"
                :to="nav.link"
                :key="nav.label"
                :class="($route.matched[1].path == nav.topPath || $route.fullPath === nav.link) ? 'active' : ''"
                class="nav-item">
                {{nav.label}}
              </router-link>
            </div>
            <p class="product-info">专业药师讲座 / 厂家授权 / 正品保证</p>
          </div>
        </div>
      </slot>
    </header>
    <!-- 固定回到导航顶部按钮 -->
    <!-- <div class="fixed-menu-block">
      <span class="f-kf"></span>
      <span class="f-to-top" @click="toTop"></span>
    </div> -->
    <!-- 登录模块 -->
    <el-dialog
      class="login-dialog"
      title="用户登录"
      :visible.sync="loginDialogVisible"
      :before-close="handleClose"
      width="30%">
      <p class="login-logo-block">
        <img src="../assets/images/logo.png" />
      </p>
      <el-form :rules="rules" :model="login" ref="LoginForm">
        <el-form-item label="" prop="phone" class="username-item">
          <el-input v-model="login.phone" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="" prop="yzm" class="yzm-item" v-if="!isLoginPassword">
          <el-input v-model="login.yzm" autocomplete="off" placeholder="请输入验证码">
            <template slot="append"><div @click="sendLoginPhone">{{count > 0 ? '倒计时'+ count: '发送验证码'}}</div></template>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="password" class="password-item" v-else>
          <el-input v-model="login.password" placeholder="请输入密码" type="password"></el-input>
        </el-form-item>
        <div class="form-local-item">
          <el-checkbox v-model="checked">记住账号</el-checkbox>
          <span @click="isLoginPassword=!isLoginPassword" style="cursor: pointer;color:#0083c4f1">{{isLoginPassword?'验证码登录':'密码登录'}}</span>
          <!-- <router-link to="/" class="">忘记密码</router-link> -->
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toLogin" class="them-btn login-long-btn">立即登录</el-button>
        <p class="login-to-register-block">没有账号？<button class="register-btn" @click="showRegiste">去注册</button></p>
      </span>
    </el-dialog>
    <!-- 注册模块 -->
    <el-dialog
      class="login-dialog"
      title="用户注册"
      :visible.sync="registerDialogVisible"
      :before-close="handleClose"
      width="30%">
      <p class="login-logo-block">
        <img src="../assets/images/logo.png" />
      </p>
      <el-form :rules="rules" :model="register" ref="registerForm">
        <el-form-item label="" prop="rphone" class="username-item">
          <el-input v-model="register.rphone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="" prop="ryzm" class="yzm-item">
          <el-input v-model="register.ryzm" autocomplete="off" placeholder="请输入验证码">
            <template slot="append"><div @click="sendRegisterPhone">{{count > 0 ? '倒计时'+ count: '发送验证码'}}</div></template>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="rPassword" class="password-item">
          <el-input v-model="register.rPassword" :type="type" autocomplete="off" placeholder="请输入密码">
            <template slot="append">
              <label @click="changeType" :class="type == 'password' ? 'password-label password-on': 'password-label password-off'"></label>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toRegister" class="them-btn login-long-btn">立即注册</el-button>
        <p class="login-to-register-block">已有账号？<button class="register-btn" @click="showLogin">去登录</button></p>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { userSendLoginMessage, userLogin, userRegist, userSendRegistLoginMessage,userLoginPassword } from "@/api/index";
import { setStore, getStore, removeStore } from "@/utils/storage";
export default {
  data() {
    return {
      isLoginPassword:false,
      login: {
        phone: '',
        yzm: '',
        password:''
      },
      register: {
        rphone: '',
        rPassword: '',
        ryzm: ''
      },
      loginDialogVisible: false,
      registerDialogVisible: false,
      checked: false,
      count: 0,
      timer: null,
      type: 'password',
      user: {},

      choosePage: -1,
      searchResults: [],
      timeout: null,
      navList: [
        {
          label: '首页',
          link: '/home',
          active: false,
          topPath: '/home'
        }, {
          label: '临床用药',
          link: '/news/newsList',
          active: false,
          topPath: '/news'
        }, {
          label: '药品查询',
          link: '/product/productList',
          active: false,
          topPath: '/product'
        }, {
          label: '新品推荐',
          link: '/newproduct/newProduct',
          active: false,
          topPath: '/newproduct'
        }, {
          label: '药品讲座',
          link: '/chair/ChairIndex',
          active: false,
          topPath: '/chair'
        }, {
          label: '关于我们',
          link: '/about/me',
          active: false,
          topPath: '/about'
        }, {
          label: '行业政策',
          link: '/industry/list',
          active: false,
          topPath: '/industry'
        }
      ],
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '电话号码长度为11', trigger: 'blur' }
        ],
        yzm: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        ryzm: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        rphone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '电话号码长度为11', trigger: 'blur' }
        ],
        rPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }    
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    toTop(){
      document.documentElement.scrollTop = 0
    },
    changeType(){
      this.type = this.type === 'password' ? 'text' : 'password';
    },
    // 发送注册码
    sendRegisterPhone(){
      if (this.count > 0) return;
      if (this.register.rphone.length !== 11){
        this.$message.error('请填写真确可用手机号！');
        return;
      }
      userSendRegistLoginMessage({CellPhone: this.register.rphone}).then((res)=>{
        if (res.Code == 200){
          this.$message.success (res.Msg);
          this.count = 60;
          this.setTimer();
          return
        }
        // this.$message.error(res.Msg);
      })
    },
    showRegiste(){
      this.loginDialogVisible= false;
      setTimeout(()=>{
        this.registerDialogVisible= true;
      },500)
    },
    showLogin(){
      this.registerDialogVisible= false;
      setTimeout(()=>{
        this.loginDialogVisible= true;
      },500)
    },
    // 发送登录码
    sendLoginPhone(){
      if (this.count > 0) return;
      if (this.login.phone.length !== 11){
        this.$message.error('请填写正确可用手机号！');
        return;
      }
      userSendLoginMessage({CellPhone: this.login.phone}).then((res)=>{
        if (res.Code == 200){
          this.$message.success (res.Msg);
          this.count = 60;
          this.setTimer();
          return
        }
        //this.$message.error(res.Msg);
      })
    },
    setTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(()=>{
        if (this.count > 0) {
          this.count = this.count-1
        } else {
          this.count = 0
        }
      },1000)
    },
    // 注册
    toRegister(){
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          let params = {
            CellPhone: this.register.rphone,
            Code: this.register.ryzm,
            Password: this.register.rPassword,
            Name: '测试名字'
          }
          userRegist(params).then((res)=>{
            if (res.Code !== 200){
              //this.$message.error(res.Msg);
              return
            }
            this.initForm();
          })
        }
      });
    },
    // 登录
    toLogin(){
      this.$refs['LoginForm'].validate((valid) => {
        if (valid) {
          if(this.isLoginPassword){
            let params = {
              userid: this.login.phone,
              password:this.login.password,
            }
            
            userLoginPassword(params).then((res)=>{
              if (res.Code !== 200){
                //this.$message.error(res.Msg);
                return
              }
              if (this.checked) {
                localStorage.setItem('phone', this.login.phone)
              }
              this.RECORD_TOKENINFO(res.Data.TokenData)
              this.RECORD_USERINFO(res.Data.UserInfo)
              this.initForm();
              if(this.$route.fullPath.indexOf('/user') > -1) {
                this.$router.push({path: '/'});
              }
              this.$nextTick(()=>{
                window.location.reload();
              })
            })
            
          }else{
            let params = {
              CellPhone: this.login.phone,
              Code: this.login.yzm,
              Password:this.login.password
            }
            
            userLogin(params).then((res)=>{
              if (res.Code !== 200){
                //this.$message.error(res.Msg);
                return
              }
              if (this.checked) {
                localStorage.setItem('phone', this.login.phone)
              }
              this.RECORD_TOKENINFO(res.Data.TokenData)
              this.RECORD_USERINFO(res.Data.UserInfo)
              this.initForm();
              if(this.$route.fullPath.indexOf('/user') > -1) {
                this.$router.push({path: '/'});
              }
              this.$nextTick(()=>{
                window.location.reload();
              })
            })
          }
          
        }
      });
    },
    handleClose(){
      this.initForm();
    },
    initForm(){
      this.registerDialogVisible = false;
      this.loginDialogVisible = false;
      this.count = 0;
      this.register.rphone = '';
      this.register.yzm = '';
      this.register.rPassword = '';
      this.login.phone = '';
      this.login.yzm = '';
      this.type = 'password';
      this.$refs['registerForm'] && this.$refs['registerForm'].resetFields();
      this.$refs['loginForm'] && this.$refs['loginForm'].resetFields();
    },
    handleCommand(command){
      if(command != 'exit') {
        this.$router.push({name: command})
      } else {
        this.$message.success('退出成功')
        removeStore("userInfo");
        removeStore("TokenData");
        this.$store.commit('RECORD_TOKENINFO', null);
        this.$store.commit('RECORD_USERINFO', null);
        // window.location.reload();
        this.$router.push('/')
      }
    },
    ...mapMutations([
      "ADD_ANIMATION",
      "RECORD_USERINFO",
      "RECORD_TOKENINFO"
    ]),
  },
  created(){
    if (localStorage.getItem('phone')) {
      this.login.phone = localStorage.getItem('phone')
    }
  },
  components: {
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
.username-item,.yzm-item,.password-item{
    .el-input__inner{
      padding-left: 40px;
    }
}
</style>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../assets/style/theme";
@import "../assets/style/mixin";
.yuding-view{
  margin-left: 15px;
  width: 96px;
  text-align: center;
  cursor: pointer;
}
.header-box {
  background-color: #fff;
  width: 100%;
}
header {
  z-index: 30;
  position: relative;
}
.w-box {
  align-items: center;
  height: 128px;
  .wh-top{
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 80px;
  }
  .nav-logo{
    width: 560px;
    height: 80px;
    background: url('../assets/images/logo.png')no-repeat left center;
    background-size: 360px 42px;
  }
  .right-nav{
    >div{
      display: inline-block;
      vertical-align: middle;
    }
  }
  
  .service-item{
    padding-left: 35px;
    height: 36px;
    margin: 0px 0;
    padding-right: 55px;
    h4{
      padding-top: 11px;
      font-size: 12px;
      line-height: 16px;
      color: #909399;
    }
    h5{
      font-size: 12px;
      font-weight: bold;
      line-height: 16px;
      color: #606266;
    }
  }
  .service-time-item{
    background: url('../assets/images/ico_header_kefu@3x.png')no-repeat left center;
    background-size: 24px 24px;
  }
  .service-phone-item{
    background: url('../assets/images/ico_header_iphone@3x.png')no-repeat left center;
    background-size: 24px 24px;
    border-right: 1px solid #EFEFEF;
  }
  .login-btn{
    margin-left: 20px;
    width: 100px;
    height: 40px;
    border-radius: 40px;
    cursor: pointer;
    
  }
  .register-btn{
    margin-left: 15px;
    border: none;
    cursor: pointer;
    &:hover {
      color: #0083c4f1;
    }
  }
  .wh-nav-box{
    border-top: solid 1px #EBEEF5;
  }
  .wh-nav{
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    height: 56px;
    line-height: 56px;
    justify-content: space-between;
  }
  .nav-item{
    display: inline-block;
    padding-right: 50px;
    font-size: 16px;
    color: #000;
    &.active{
      color: #0084c4;
      font-weight: bold;
    }
  }
  .product-info{
    color: #0084C4;
    font-size: 14px;
    font-weight: 400;
  }
}
.fixed-menu-block{
  position: fixed;
  right: 0;
  top: 60vh;
  z-index: 999;
  padding-right: 15px;
  .f-kf{
    display: block;
    cursor: pointer;
    width: 48px;
    height: 48px;
    background: url('../assets/images/ico_fixed_kefu@2x.png')no-repeat center;
    background-size: 48px 48px;
  }
  .f-to-top{
    display: block;
    cursor: pointer;
    margin-top: 4px;
    width: 48px;
    height: 48px;
    background: url('../assets/images/ico_fixed_move_top@2x.png')no-repeat center;
    background-size: 48px 48px;
  }
}
.login-logo-block{
  padding: 0 0 50px 0;
  text-align: center;
  img{
    width: 360px;
  }
}
/deep/.login-dialog{
  .el-dialog--small{
    max-width: 420px;
  }
}
.username-item{
  .el-input{
    // border: 1px solid #bfcbd9;
    border-radius: 4px;
    &::before{
      position: absolute;
      left: 0;
      display: inline-block;
      content: '';
      width: 50px;
      height: 36px;
      background: url('../assets/images/ico_sign_username@2x.png')no-repeat center;
      background-size: 16px 16px;
    }
    .el-input__inner{
      padding-left: 40px;
      width: 80%;
      border: none;
      margin-left: 35px;
    }
  }
}
.password-item{
  .el-input{
    // border: 1px solid #bfcbd9;
    border-radius: 4px;
    &::before{
      position: absolute;
      left: 0;
      display: inline-block;
      content: '';
      width: 50px;
      height: 36px;
      background: url('../assets/images/ico_sign_pwd@2x.png')no-repeat center;
      background-size: 16px 16px;
    }
  }
  /deep/.el-input__inner{
    width: 80%;
    border: none;
    margin-left: 35px;
  }
  /deep/.el-input-group__append{
    border: none;
    cursor: pointer;
  }
}
.yzm-item{
  .el-input{
    // border: 1px solid #bfcbd9;
    border-radius: 4px;
    &::before{
      position: absolute;
      left: 0;
      display: inline-block;
      content: '';
      width: 50px;
      height: 36px;
      background: url('../assets/images/ico_sign_code@2x.png')no-repeat center;
      background-size: 16px 16px;
    }
  }
  /deep/.el-input-group__append{
    border: none;
    border-left: solid 1px #bfcbd9;
    cursor: pointer;
  }
  /deep/.el-input__inner{
    width: 80%;
    border: none;
    margin-left: 35px;
  }
}
.form-local-item{
  display: flex;
  justify-content: space-between;
  .el-checkbox__input{
    transform: scale(0.8);
  }
}
.login-long-btn{
  width: 100%;
}
.login-to-register-block{
  padding: 20px 0;
  text-align: center;
  .register-btn{
    cursor: pointer;
    background-color: #fff;
    color: #0084C4;
  }
}
.password-label{
  display: block;
  border: none;
  width: 50px;
  height: 36px;
  cursor: pointer;
}
.password-on{
  background: url('../assets/images/ico_sign_eye_on@2x.png')no-repeat center;
  background-size: 16px auto;
}
.password-off{
  background: url('../assets/images/ico_sign_eye_off@2x.png')no-repeat center;
  background-size: 16px auto;
}
@media (max-height: 780px) {
  .nav-cart-items {
    max-height: 423px !important;
  }
} 

@media (max-height: 900px) {
  .nav-cart-items {
    max-height: 544px !important;
  }
}

@media (max-height: 1080px) {
  .nav-cart-items {
    max-height: 620px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/common/header.vue